<template>
    <div
        id="pluto-effect"
        ref="root"
        class="pluto-effect"
        v-bind:class="{'only-nft': onlyNft}"
    >
        <!-- <div class="effect-item ef-b5 show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/b0.png')"
            >
        </div> -->

        <!-- fade-big -->
        <!-- <div class="effect-item ef-fade-big show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/b0.png')"
            >
        </div> -->

        <!-- Rotate -->
        <!-- <div class="effect-item ef-rotate-item show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/b3.png')"
            >
        </div> -->

        <!-- waterfall -->
        <!-- 玫瑰話隨機位置掉落 -->
        <!-- <div class="effect-item ef-waterfall top-bottom show">
            <div class="box">
                <img
                    v-for="i in 6"
                    v-bind:key="i"
                    v-bind:src="require('@/assets/images/hiphop/ef/c1.png')"
                    v-bind:style="{
                        'transform': `translateY(${(Math.random() * 90 + 10) / 10 * 15}px`
                    }"
                >
            </div>
        </div> -->

        <!-- two-bump -->
        <!-- <div class="effect-item ef-two-bump show">
            <div class="box">
                <img
                    v-for="i in 2"
                    v-bind:key="i"
                    v-bind:src="require('@/assets/images/hiphop/ef/b6.png')"
                >
            </div>
        </div> -->

        <!-- bounce-in-top -->
        <!-- <div class="effect-item ef-bounce-in-top show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/c3.png')"
            >
        </div> -->

        <!-- jello-horizontal -->
        <!-- <div class="effect-item ef-jello-horizontal show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/b1.png')"
            >
        </div> -->
        <!--  -->
        <!-- <div class="effect-item ef-slide-out-fwd-center show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/b4.png')"
            >
        </div> -->

        <!-- sprint-pause -->
        <!-- <div class="effect-item ef-sprint-pause show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/c2.png')"
            >
        </div> -->

        <!-- heartbeat  -->
        <!-- <div class="effect-item ef-heartbeat show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/c0.png')"
            >
        </div> -->

        <!-- gungun -->
        <!-- <div class="effect-item ef-gungun show">
            <img
                v-bind:src="require('@/assets/images/hiphop/ef/free-b7.png')"
            >
        </div> -->
    </div>
</template>

<script setup lang="ts">
    import { defineProps, ref, onMounted, computed, onUnmounted } from 'vue';
    import ImageA from '@/assets/images/demi/a.png';
    import ImageB from '@/assets/images/demi/b.png';
    import ImageC from '@/assets/images/demi/c.png';
    import ImageD from '@/assets/images/demi/d.png';

    const require = (name: string) => {
        const key = name[0];
        switch (key) {
            case 'b':
                return ImageB;
            case 'c':
                return ImageC;
            case 'd':
                return ImageD;
            case 'a':
            default:
                return ImageA;
        }
    };

    const props = defineProps({
        onlyNft: {
            type: Boolean,
            default: () => false,
        },
        onParentFunc: {
            type: Function,
            required: true,
        },
    });
    const root = ref<Element>();
    const rootSize = computed(() => ({
        width: root.value?.clientWidth || 1024,
        height: root.value?.clientHeight || 600,
    }));
    const edgeSize = computed(() => rootSize.value.width * 0.15);
    // const rootViewSize = computed(() => {
    //   return {
    //     width: root.value?.clientWidth || 1024,
    //     height: root.value?.clientHeight || 600,
    //   };
    // });
    const animations = {
        animateFadeIn(name: string, time = 1000) {
            const ele = createElement(name, 'effect-item ef-fade-in');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);
            const { x, y } = getRandomPosition(edgeSize.value);
            ele.style.left = `${x}px`;
            ele.style.top = `${y}px`;

            remove(ele, time);
        },
        animateFadeInBatch(name = 'free-b5', time = 1000) {
            new Array(Math.round((Math.random() * 5) + 3)).fill(0).forEach(() => {
                animations.animateFadeIn(name, time);
            });
        },
        fadeInCenterBig(name = 'free-b6', time = 500) {
            const ele = createElement(name, 'effect-item ef-fade-big');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);

            remove(ele, time);
        },
        rotateRandom(name = 'b2', time = 500) {
            const ele = createElement(name, 'effect-item ef-rotate-item');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);
            const { x, y } = getRandomPosition();
            ele.style.left = `${x}px`;
            ele.style.top = `${y}px`;

            remove(ele, time);
        },
        rotateRandomBatch(name = 'b3', time = 500) {
            new Array(Math.round((Math.random() * 5) + 3)).fill(0).forEach(() => {
                animations.rotateRandom(name, time);
            });
        },
        bounceInTop(name = 'c3', time = 700) {
            const ele = createElement(name, 'effect-item ef-bounce-in-top');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);
            if (Math.random() > 0.5) {
                // img.style.transform = 'rotate(90deg)';
                ele.style.bottom = `${(Math.random() * 7 + 1) / 10 * rootSize.value.height}px`;
                ele.style.left = '-20%';
                ele.style.opacity = '0.2';
                setTimeout(() => {
                    ele.style.left = '120%';
                    ele.style.opacity = '1';
                }, 50);
            } else {
                ele.style.bottom = '115%';
                ele.style.left = `${(Math.random() * 7 + 1) / 10 * rootSize.value.width}px`;
                ele.style.opacity = '0.2';
                setTimeout(() => {
                    ele.style.bottom = '-20%';
                    ele.style.opacity = '1';
                }, 50);
            }
            remove(ele, time);
        },
        waterfall(name = 'c1', time = 700) {
            let offset = 0;
            const num = props.onlyNft ? 6 : 13;
            const offsetBase = Math.round(rootSize.value.width / num);
            new Array(num).fill(0).forEach((_, i) => {
                const ele = createElement(name, 'effect-item ef-waterfall top-bottom');
                ele.style.transform = `translateX(${offset}px)`;
                const box = createElement(name, 'box');
                setTimeout(() => {
                    const img = createElement(`${name}-img-${i}`, '', 'img');
                    img.setAttribute('src', require(name));
                    box.append(img);
                    ele.append(box);

                    remove(ele, time);
                }, (Math.random() * 30) * 3 * i);
                offset += offsetBase;
            });
        },
        twoBump(name = 'b6', time = 500) {
            const ele = createElement(name, 'effect-item ef-two-bump');
            const box = createElement(name, 'box');
            new Array(2).fill(0).forEach((_, i) => {
                const img = createElement(`${name}-img-${i}`, '', 'img');
                img.setAttribute('src', require(name));
                if (name === 'c7') {
                    img.style.transform = 'scale(1.3)';
                }
                box.append(img);
                return img;
            });
            ele.append(box);

            remove(ele, time);
        },
        jelloHorizontal(name = 'b1', time = 600) {
            const ele = createElement(name, 'effect-item ef-jello-horizontal');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);
            const { x, y } = getRandomPosition();
            ele.style.left = `${x}px`;
            ele.style.top = `${y}px`;

            remove(ele, time);
        },
        slideOut(name = 'b4', time = 500) {
            const ele = createElement(name, 'effect-item ef-slide-out-fwd-center');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);

            remove(ele, time);
        },
        heartbeat(name = 'b8', time = 700) {
            const ele = createElement(name, 'effect-item ef-heartbeat');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            ele.append(img);
            const { x, y } = getRandomPosition();
            ele.style.left = `${x}px`;
            ele.style.top = `${y}px`;

            remove(ele, time);
        },
        sprintPause(name = 'c2', time = 700) {
            const ele = createElement(name, 'effect-item ef-sprint-pause');
            const img = createElement(`${name}-img`, '', 'img');
            img.setAttribute('src', require(name));
            if (props.onlyNft) {
                if (name === 'b3') {
                    img.style.width = `${rootSize.value.width * 0.53}px`;
                    ele.style.transform = 'translateX(-40%) translateY(-36%)';
                }
                if (name === 'c2') {
                    img.style.width = `${rootSize.value.width * 0.45}px`;
                    // ele.style.transform = 'translateX(-40%) translateY(-36%)';
                }
            }
            ele.append(img);

            remove(ele, time);
        },
        gungun(name = 'free-b7', time = 700) {
            const ele = createElement(name, 'effect-item ef-gungun');
            const img = createElement(`${name}-img`, '', 'img');
            let startLeft = Math.random();
            if (startLeft <= 0.5) {
                startLeft = Math.max(startLeft, 0.1);
                startLeft = Math.min(startLeft, 0.35);
                img.setAttribute('src', require(name));
            } else {
                startLeft = Math.max(startLeft, 0.65);
                startLeft = Math.min(startLeft, 0.85);
                img.setAttribute('src', require(name));
            }
            ele.style.left = `${startLeft * rootSize.value.width}px`;

            ele.style.bottom = `${(Math.random() * 5 + 1) / 10 * rootSize.value.height}px`;
            ele.append(img);

            remove(ele, time);
        },
    };
    function remove(ele: Element, time: number) {
        root.value?.append(ele);
        setTimeout(() => {
            ele.innerHTML = '';
            ele.remove();
        }, time);
    }
    // onMounted(() => {
    //   // console.log(animations, root.value);
    window.ani = animations;
    window.ani2 = animateHandler;
    // });
    // const clerup = () => props.onParentFunc(animateHandler);
    onMounted(() => {
        // clerup();
        props.onParentFunc(animateHandler);
        [ImageA, ImageB, ImageC, ImageD].forEach((img) => {
            preloadImage(img);
        });
    });

    function preloadImage(url: string) {
        const img = new Image();
        img.src = url;
    }

    function animateHandler(key: string) {
        // console.log('animateHandler', key);
        key = key.toLowerCase();
        switch (key) {
            case 'b1':
            case 'd1':
                animations.animateFadeInBatch(key); // 排列沒有美感
                break;
            case 'a0': // 正中間 淡入 大
                animations.fadeInCenterBig(key);
                break;
            // rotate
            case 'b0': // 旋轉
                animations.rotateRandomBatch(key);
                break;
            // bounce-in-top
            case 'b2': // 衝刺
                animations.bounceInTop(key);
                break;
            // sprint-pause
            // case 'b2': // 左邊飛入中間停住右邊非出
            case 'c2': // 左邊飛入中間停住右邊非出
                // TODO: 人物頭上

                animations.sprintPause(key);
                break;
            // waterfall
            case 'a1':
                animations.waterfall(key);
                break;
            // two-bump
            case 'd0':
                animations.twoBump(key);
                break;
            // jello-horizontal
            case 'c0': // 變大
                animations.jelloHorizontal(key);
                break;
            // slide-out-fwd-center
            case 'c1':
            case 'd2': // 中間變大
                animations.slideOut(key);
                break;
            // ef-heartbeat
            case 'a2':
                animations.heartbeat(key);
                break;
            // ef-gungun
            // case 'free-b7': // https://animista.net/play/entrances/flicker-in
            //     animations.gungun(key);
            //     break;
            default:
                // console.log('effect', key);
                break;
        }
    }

    function createElement(name: string, className: string, tag = 'div') {
        const ele = document.createElement(tag);
        ele.setAttribute('class', `${className}`);
        return ele;
    }

    function getRandomPosition(edge = 200) {
        const { width, height } = rootSize.value;
        const x = Math.random() * (width - edge);
        const y = Math.random() * (height - edge);
        return { x, y };
    }

</script>

<style lang="scss">
@import '@/scss/foundation/config';

.pluto-effect {
  width: 100%;
  height: 100%;
  position: absolute;

  .effect-item {
    z-index: 4;
    position: absolute;
    // max-width: 200px;
    display: inline-block;
    opacity: 0;

    img {
      max-width: 360px;
    }

    // transform: opacity .3s ease-out;
    // transform: all ;

    &.show {
      opacity: 1;
      animation-iteration-count: infinite !important;
    }

    &.ef-fade-in {
      left: calc(100vw - 50%);
      bottom: 40%;

      img {
        width: 190px;
      }

      animation: fade-in 500ms ease-out;

      @keyframes fade-in {
        0% {
          opacity: 0;
          // bottom: -50%;
        }

        50% {
          opacity: 1;
          // bottom: 27%;
        }

        100% {
          opacity: 0;
          // bottom: 27%;
        }
      }
    }

    &.ef-fade-big {
      // left: calc(50vw - 25vw);
      // bottom: calc(50vh - 35vh);
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        // width: 65vh;
        width: 65vh;
        max-width: initial;
      }

      animation: fade-big 500ms ease-out;

      @keyframes fade-big {
        0% {
          opacity: 0;
          // transform: scale(1);
          // bottom: -50%;
        }

        50% {
          opacity: 1;
          // transform: scale(1.3);
          // bottom: 27%;
        }

        100% {
          opacity: 0;
          // transform: scale(0.5);
          // bottom: 27%;
        }
      }

    }

    //
    &.ef-rotate-item {
      left: calc(100vw - 50%);
      bottom: 40%;

      img {
        width: 160px;
      }

      animation: rotate-item 500ms ease-out;

      @keyframes rotate-item {
        0% {
          opacity: 0;
          transform: rotate(0);
          // bottom: -50%;
        }

        80% {
          opacity: 1;
          transform: rotate(360deg);
          // bottom: 27%;
        }

        100% {
          opacity: 0;
          transform: rotate(360deg);
          // bottom: 27%;
        }
      }
    }

    &.ef-waterfall {
      left: 0;
      top: 0%;
      width: 100%;
      height: 100%;

      .box {
        &>* {
          display: inline-block;
          width: 9%;
          height: auto;
        }
      }

      &.top-bottom {
        animation: waterfall-top-bottom 500ms linear;

        @keyframes waterfall-top-bottom {
          0% {
            opacity: .1;
            // transform: translateY(0);
            // bottom: -50%;
            top: 0%;
          }

          50% {
            opacity: 1;
            // transform: translateY(0);
            // bottom: 27%;
            top: 50%;
          }

          100% {
            opacity: 0;
            top: 100%;
            // transform: rotate(360deg);
            // bottom: 27%;
          }
        }
      }

      &.left-right {
        // width: 80%;
        // top: 25%;
        left: initial;
        right: 0%;
        animation: waterfall-left-right 500ms linear;

        img {
          width: 50%;
        }

        @keyframes waterfall-left-right {
          0% {
            opacity: .1;
            // transform: translateY(0);
            // bottom: -50%;
            right: 0%;
          }

          50% {
            opacity: 1;
            // transform: translateY(0);
            // bottom: 27%;
            right: 25%;
          }

          100% {
            opacity: 0;
            right: 100%;
            // transform: rotate(360deg);
            // bottom: 27%;
          }
        }
      }
    }

    //
    &.ef-two-bump {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      animation: two-bump 500ms ease-out;

      .box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 45%;
        }

      }

      @keyframes two-bump {
        0% {
          opacity: .1;
          transform: scale(.5);
          // bottom: -50%;
          // top: 0%;
        }

        50% {
          opacity: 1;
          transform: scale(1);
          // bottom: 27%;
          // top: 50%;
        }

        100% {
          opacity: 1;
          // top: 100%;
          transform: scale(.8);
          // bottom: 27%;
        }
      }
    }

    //
    &.ef-bounce-in-top {

      // bottom: 0;
      // width: 100%;
      // height: 100%;
      img {
        width: 210px;
        height: auto;
      }

      transition: all 700ms ease-in-out;

      // animation: bounce-in-top 700ms ease-out;
      @keyframes bounce-in-top {
        0% {
          bottom: 100%;
          opacity: 0.2;
        }

        50% {
          // bottom: 40%;
          opacity: .8;
        }

        100% {
          bottom: -30%;
          opacity: 1;
        }
      }
    }

    //
    &.ef-jello-horizontal {
      animation: jello-horizontal 0.6s both;
      img {
        max-width: 390px;
      }
      @keyframes jello-horizontal {
        0% {
          opacity: 0.1;
          transform: scale3d(1, 1, 1);
        }

        30% {
          transform: scale3d(1.25, 0.75, 1);
        }

        40% {
          opacity: 1;
          transform: scale3d(0.75, 1.25, 1);
        }

        50% {
          transform: scale3d(1.15, 0.85, 1);
        }

        65% {
          transform: scale3d(0.95, 1.05, 1);
        }

        75% {
          transform: scale3d(1.05, 0.95, 1);
        }

        100% {
          transform: scale3d(1, 1, 1);
        }
      }

    }

    &.ef-sprint-in {
      left: 0;
      top: 0%;
      width: 100%;
      height: 100%;

      .box {
        &>* {
          display: inline-block;
          width: 9%;
          height: auto;
        }
      }
    }

    &.ef-slide-out-fwd-center {
      width: 100%;
      text-align: center;

      img {
        margin: 0 auto;
      }
      bottom: 30%;
      animation: slide-out-fwd-center 500ms cubic-bezier(0.550, 0.085, 0.680, 0.530) both;

      @keyframes slide-out-fwd-center {
        0% {
          transform: translateY(0%) scale(.6);
          opacity: 1;
        }

        100% {
          transform: translateY(0%) scale(2);
          opacity: .2;
        }
      }
    }

    //
    &.ef-sprint-pause {
      left: 0;
      top: 40vh;
      transform: translateX(-50%) translateY(-50%);
      img {
        width: 175px;
      }

      animation: sprint-pause 700ms linear;

      @keyframes sprint-pause {
        0% {
          left: -10%;
          opacity: 1;
        }

        30% {
          left: 50%;
          opacity: 1;
        }

        70% {
          left: 50%;
          opacity: 1;
        }

        100% {
          left: 120%;
          opacity: 1;
        }
      }
    }

    //
    &.ef-heartbeat {
      img {
        width: 33vh;
      }

      animation: heartbeat 700ms ease-in-out infinite both;

      @keyframes heartbeat {
        from {
          opacity: .1;
          transform: scale(1);
          transform-origin: center center;
          animation-timing-function: ease-out;
        }

        10% {
          transform: scale(0.61);
          animation-timing-function: ease-in;
        }

        17% {
          opacity: 1;
          transform: scale(0.98);
          animation-timing-function: ease-out;
        }

        33% {
          transform: scale(0.77);
          animation-timing-function: ease-in;
        }

        66% {
          opacity: 1;
          transform: scale(1);
          animation-timing-function: ease-out;
        }

        76% {
          opacity: .8;
        }

        100% {
          opacity: 0;
          ;
        }
      }

    }

    //
    &.ef-gungun {
      img {
        width: 180px;
        transform: translateX(-50%);
      }

      animation: gungun 700ms ease-out;

      @keyframes gungun {
        0% {
          opacity: 0.1;
          transform: rotate(0);
          // bottom: -50%;
        }

        30% {
          opacity: 1;
          transform: rotate(45deg);
          // bottom: 27%;
        }

        78% {
          opacity: 1;
          transform: rotate(11deg);
          // bottom: 27%;
        }
      }
    }
  }

  &.only-nft {
    .effect-item {

      img {
        max-width: initial;
      }
      &.ef-gungun {
        img {
          width: 130px;
        }
      }
      &.ef-fade-in {
        img {
          width: 120px;
        }
      }
      &.ef-waterfall {
        img {
          width: 16%;
        }
      }
      &.ef-fade-big {
        img {
          width: 90vh;
        }
      }
      &.ef-sprint-pause {
        transform: translateX(-50%) translateY(-42%);
        top: 50%;
        img {
        }

        animation: sprint-pause-nft 700ms linear;

        @keyframes sprint-pause-nft {
          0% {
            left: -10%;
            opacity: 1;
          }

          30% {
            left: 55%;
            opacity: 1;
          }

          70% {
            left: 55%;
            opacity: 1;
          }

          100% {
            left: 120%;
            opacity: 1;
          }
        }
      }
      &.ef-slide-out-fwd-center {
        height: 100%;
        bottom: 0;
        display: flex;
        justify-content: center;

      }
      &.ef-jello-horizontal {
        img {
          width: 210px
        }
      }
    }
  }
}

</style>
